"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultProps = exports.MultiTagDropdown = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = require("../../foundation/Icons");

var _InputField = _interopRequireDefault(require("../../elements/Forms/InputField"));

var _Tag = _interopRequireDefault(require("../../elements/Tag"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var MultiTagDropdown = function MultiTagDropdown(props) {
  var classNames = props.classNames,
      children = props.children,
      name = props.name,
      onChange = props.onChange,
      defaultValues = props.defaultValues,
      selected = props.selected,
      onSearch = props.onSearch,
      clearSearchOnSelect = props.clearSearchOnSelect,
      id = props.id,
      label = props.label,
      hideTags = props.hideTags;
  var multiTagDropdownRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      searchValue = _useState4[0],
      setSearchValue = _useState4[1]; // change handler for search input


  var handleSearch = function handleSearch(searchString) {
    setSearchValue(searchString);

    if (onSearch) {
      onSearch(searchString);
    }
  };

  var _useState5 = (0, _react.useState)(defaultValues),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedValues = _useState6[0],
      setSelectedValues = _useState6[1]; // on input focus, open the menu


  var handleFocus = function handleFocus() {
    setIsOpen(true);
  }; // create document listener for outside clicks


  var outsideClickListener = function outsideClickListener(event) {
    if (multiTagDropdownRef.current !== null) {
      var currentRef = multiTagDropdownRef.current; // if the click is not within our component, we close the dropdown

      if (!currentRef.contains(event.target)) {
        setIsOpen(false);
      }
    }
  };
  /**
   * Using useEffect to add/remove document listener for outside clicks
   */


  (0, _react.useEffect)(function () {
    // add outside click listener
    document.addEventListener('click', outsideClickListener); // cleanup outside click listener

    var cleanUpListener = function cleanUpListener() {
      document.removeEventListener('click', outsideClickListener);
    };

    return cleanUpListener;
  }, []);
  /**
   * Use effect to set selected when prop is passed
   */

  (0, _react.useEffect)(function () {
    if (selected) {
      setSelectedValues(selected);
    }
  }, [selected]); // used to lookup the label for a menu item based on its value for displaying a tag

  var getLabelFromChildren = function getLabelFromChildren(value) {
    var result = _lodash.default.find(_react.default.Children.toArray(children), function (child) {
      return _lodash.default.get(child, ['props', 'value']) === value;
    });

    return _lodash.default.get(result, ['props', 'label'], null);
  }; // used to remove a value from selectedValues


  var removeSelectedItem = function removeSelectedItem(value) {
    var nextValues = _lodash.default.filter(selectedValues, function (selectedValue) {
      return selectedValue !== value;
    });

    setSelectedValues(_toConsumableArray(nextValues));
    onChange(nextValues);
  };
  /**
   * renderOptions only renders the children that are not currently selected
   */


  var renderOptions = function renderOptions() {
    return _react.default.Children.map(_react.default.Children.toArray(children), function (child) {
      var value = child.props.value; // if an onSearch handler was not provided, and there is a search string, then do basic
      // filtering based on the label using _.includes

      if (_lodash.default.isUndefined(onSearch) && searchValue !== '') {
        var optionLabel = _lodash.default.get(child, ['props', 'label']);

        if (!_lodash.default.includes(optionLabel.toLowerCase(), searchValue.toLowerCase())) {
          return null;
        }
      } // if the value on the child is in the selectedValues array, return null so it's not rendered


      if (selectedValues.length > 0 && selectedValues.indexOf(value) !== -1) {
        return null;
      }

      var originalOnClick = child.props.onClick;
      var originalClassNames = child.props.classNames;

      var modifiedOnClick = function modifiedOnClick() {
        var nextValues = [].concat(_toConsumableArray(selectedValues), [child.props.value]); // add the value to selected values

        setSelectedValues(nextValues); // fire onChange

        onChange(nextValues); // clear search if required

        if (clearSearchOnSelect) {
          setSearchValue('');
        } // hide the dropdown


        setIsOpen(false); // fire the original onClick

        originalOnClick();
      };

      return _react.default.cloneElement(child, {
        onClick: function onClick() {
          modifiedOnClick();
        },
        classNames: (0, _classnames.default)(originalClassNames, 'kubra-ux-multi-tag-dropdown__menu__items__item')
      });
    });
  };

  var multiTagDropdownClassNames = {
    'kubra-ux-multi-tag-dropdown': true
  };
  var menuClassNames = {
    'kubra-ux-multi-tag-dropdown__menu': true,
    'kubra-ux-multi-tag-dropdown__menu--without-label': _lodash.default.isUndefined(label),
    'kubra-ux-multi-tag-dropdown__menu--with-label': !_lodash.default.isUndefined(label)
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(multiTagDropdownClassNames, classNames),
    ref: multiTagDropdownRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "kubra-ux-multi-tag-dropdown__search"
  }, /*#__PURE__*/_react.default.createElement(_InputField.default, {
    id: id,
    name: name,
    label: label,
    icon: /*#__PURE__*/_react.default.createElement(_Icons.IcoSearch, null),
    placeholder: "Search",
    classNames: "kubra-ux-multi-tag-dropdown__search__input",
    onFocus: handleFocus,
    onChangeValue: handleSearch,
    value: searchValue,
    hideError: true
  })), !hideTags && /*#__PURE__*/_react.default.createElement("div", {
    className: "kubra-ux-multi-tag-dropdown__selected_tags"
  }, selectedValues.map(function (value) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "kubra-ux-multi-tag-dropdown__selected_tags__tag_container",
      key: value
    }, /*#__PURE__*/_react.default.createElement(_Tag.default, {
      onClick: function onClick() {
        removeSelectedItem(value);
      }
    }, getLabelFromChildren(value)));
  })), isOpen && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(menuClassNames)
  }, !hideTags && /*#__PURE__*/_react.default.createElement("div", {
    className: "kubra-ux-multi-tag-dropdown__menu__selected_tags"
  }, selectedValues.map(function (value) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "kubra-ux-multi-tag-dropdown__menu__selected_tags__tag_container",
      key: value
    }, /*#__PURE__*/_react.default.createElement(_Tag.default, {
      onClick: function onClick() {
        removeSelectedItem(value);
      }
    }, getLabelFromChildren(value)));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "kubra-ux-multi-tag-dropdown__menu__items"
  }, renderOptions())));
};

exports.MultiTagDropdown = MultiTagDropdown;
MultiTagDropdown.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  defaultValues: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  clearSearchOnSelect: _propTypes.default.bool.isRequired,
  hideTags: _propTypes.default.bool.isRequired,
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]).isRequired,
  name: _propTypes.default.string,
  label: _propTypes.default.string,
  selected: _propTypes.default.arrayOf(_propTypes.default.string),
  onChange: _propTypes.default.func.isRequired,
  onSearch: _propTypes.default.func
};
var defaultProps = {
  classNames: {},
  defaultValues: [],
  clearSearchOnSelect: true,
  hideTags: false
};
exports.defaultProps = defaultProps;
MultiTagDropdown.defaultProps = defaultProps;
var _default = MultiTagDropdown;
exports.default = _default;